/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as accessV1 from "./keyapis_device_access_v1.pb"
import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * События устройств (домофоны, калитки, шлагбаумы)
 */

/**
 * Справочник статусов конфигурации устройства.
 */
export enum ConfigureDeviceResultTaskSettingsStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Настроен
   */
  SUCCESS = "SUCCESS",
  /**
   * Ошибка
   */
  ERROR = "ERROR",
}
/**
 * Справочник статусов конфигурации устройства.
 */
export type ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum = keyof typeof ConfigureDeviceResultTaskSettingsStatusType
/**
 * Справочник статусов конфигурации устройства.
 */
export type ConfigureDeviceResultTaskSettingsStatusTypeRequestEnum = Exclude<ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Задача ответ на ошибку при разблокировке аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_activate_fail
 */
export type ActivateCmsPhoneFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Дата и время события
   */
  occuredAt: string
}
/**
 * Задача ответ на ошибку при разблокировке аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_activate_fail
 */
export type ActivateCmsPhoneFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Дата и время события
   */
  occuredAt: string
}
/**
 * Задача ответ на успешную разблокировку аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_activate_success
 */
export type ActivateCmsPhoneSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Дата и время разблокировки аналоговой трубки
   */
  activatedAt: string
}
/**
 * Задача ответ на успешную разблокировку аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_activate_success
 */
export type ActivateCmsPhoneSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Дата и время разблокировки аналоговой трубки
   */
  activatedAt: string
}
/**
 * Задача разблокировку аналоговых трубок на устройстве для квартир.
 * Очередь key.device.cms_phones_activate
 */
export type ActivateCmsPhonesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Список аналоговых трубок
   */
  cmsPhones?: ActivateCmsPhonesTaskCmsPhoneRequestDto[]
}
/**
 * Задача разблокировку аналоговых трубок на устройстве для квартир.
 * Очередь key.device.cms_phones_activate
 */
export type ActivateCmsPhonesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Список аналоговых трубок
   */
  cmsPhones: ActivateCmsPhonesTaskCmsPhoneResponseDto[]
}
/**
 * Аналоговая трубка
 */
export type ActivateCmsPhonesTaskCmsPhoneRequestDto = {
  /**
   * Идентификатор аналоговой трубки
   */
  id: number
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Аналоговая трубка
 */
export type ActivateCmsPhonesTaskCmsPhoneResponseDto = {
  /**
   * Идентификатор аналоговой трубки
   */
  id: number
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Задача ответ на неуспешное на добавление кодов на устройство.
 * Очередь key.device.add_codes_fail
 */
export type AddCodesFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки кодов
   */
  codeErrors: CodeErrorRequestDto[]
}
/**
 * Задача ответ на неуспешное на добавление кодов на устройство.
 * Очередь key.device.add_codes_fail
 */
export type AddCodesFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки кодов
   */
  codeErrors: CodeErrorResponseDto[]
}
/**
 * Задача ответ на успешное на добавление кодов на устройство.
 * Очередь key.device.add_codes_success
 */
export type AddCodesSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * коды
   */
  codes: CodeRequestDto[]
}
/**
 * Задача ответ на успешное на добавление кодов на устройство.
 * Очередь key.device.add_codes_success
 */
export type AddCodesSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * коды
   */
  codes: CodeResponseDto[]
}
/**
 * Задача на добавление кодов на устройство.
 * Очередь key.device.add_codes
 */
export type AddCodesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  codes: CodeRequestDto[]
}
/**
 * Задача на добавление кодов на устройство.
 * Очередь key.device.add_codes
 */
export type AddCodesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  codes: CodeResponseDto[]
}
/**
 * Задача ответ на неуспешное на добавление ключей на устройство.
 * Очередь key.device.add_rfids_fail
 */
export type AddRfidsFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки ключей
   */
  rfidErrors: RfidErrorRequestDto[]
}
/**
 * Задача ответ на неуспешное на добавление ключей на устройство.
 * Очередь key.device.add_rfids_fail
 */
export type AddRfidsFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки ключей
   */
  rfidErrors: RfidErrorResponseDto[]
}
/**
 * Задача ответ на успешное на добавление ключей на устройство.
 * Очередь key.device.add_rfids_success
 */
export type AddRfidsSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidRequestDto[]
}
/**
 * Задача ответ на успешное на добавление ключей на устройство.
 * Очередь key.device.add_rfids_success
 */
export type AddRfidsSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidResponseDto[]
}
/**
 * Задача на добавление ключей на устройство.
 * Очередь key.device.add_rfids
 */
export type AddRfidsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidRequestDto[]
}
/**
 * Задача на добавление ключей на устройство.
 * Очередь key.device.add_rfids
 */
export type AddRfidsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidResponseDto[]
}
/**
 * Задача на добавление Sl3 ключей на устройство.
 * Очередь key.device.add_sl3_rfids
 */
export type AddSl3RfidsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  sl3Rfids: AddSl3RfidsTaskSl3RfidRequestDto[]
}
/**
 * Задача на добавление Sl3 ключей на устройство.
 * Очередь key.device.add_sl3_rfids
 */
export type AddSl3RfidsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  sl3Rfids: AddSl3RfidsTaskSl3RfidResponseDto[]
}
/**
 * Ключ sl3
 */
export type AddSl3RfidsTaskSl3RfidRequestDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Значение ключа
   */
  key: string
  /**
   * Секрет
   */
  keySecret: string
}
/**
 * Ключ sl3
 */
export type AddSl3RfidsTaskSl3RfidResponseDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Значение ключа
   */
  key: string
  /**
   * Секрет
   */
  keySecret: string
}
/**
 * Задача ответ на ошибку при блокировке аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_block_fail
 */
export type BlockCmsPhoneFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Дата и время события
   */
  occuredAt: string
}
/**
 * Задача ответ на ошибку при блокировке аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_block_fail
 */
export type BlockCmsPhoneFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Дата и время события
   */
  occuredAt: string
}
/**
 * Задача ответ на успешную блокировку аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_block_success
 */
export type BlockCmsPhoneSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Дата и время блокировки аналоговой трубки
   */
  blockedAt: string
}
/**
 * Задача ответ на успешную блокировку аналоговой трубки на устройстве для квартиры.
 * Очередь key.device.cms_phone_block_success
 */
export type BlockCmsPhoneSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор аналоговой трубки
   */
  cmsPhoneId: number
  /**
   * Дата и время блокировки аналоговой трубки
   */
  blockedAt: string
}
/**
 * Задача на блокировку аналоговых трубок на устройствах для квартир.
 * Очередь key.device.cms_phones_block
 */
export type BlockCmsPhonesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Список аналоговых трубок
   */
  cmsPhones?: BlockCmsPhonesTaskCmsPhoneRequestDto[]
}
/**
 * Задача на блокировку аналоговых трубок на устройствах для квартир.
 * Очередь key.device.cms_phones_block
 */
export type BlockCmsPhonesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Список аналоговых трубок
   */
  cmsPhones: BlockCmsPhonesTaskCmsPhoneResponseDto[]
}
/**
 * Аналоговая трубка
 */
export type BlockCmsPhonesTaskCmsPhoneRequestDto = {
  /**
   * Идентификатор аналоговой трубки
   */
  id: number
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Аналоговая трубка
 */
export type BlockCmsPhonesTaskCmsPhoneResponseDto = {
  /**
   * Идентификатор аналоговой трубки
   */
  id: number
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Сообщение о появлении возможности работы с аналоговыми трубками на устройстве.
 * Очередь key.device.device_cms_available
 */
export type CmsAvailableTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Сообщение о появлении возможности работы с аналоговыми трубками на устройстве.
 * Очередь key.device.device_cms_available
 */
export type CmsAvailableTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Задача на использование аналоговых трубок.
 * Очередь key.device.cms_available
 */
export type CmsServiceAvailableTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
}
/**
 * Задача на использование аналоговых трубок.
 * Очередь key.device.cms_available
 */
export type CmsServiceAvailableTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
}
/**
 * Код
 */
export type CodeRequestDto = {
  /**
   * Идентификатор кода
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер помещения к которому прявязан код
   */
  roomNumber: string
}
/**
 * Код
 */
export type CodeResponseDto = {
  /**
   * Идентификатор кода
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер помещения к которому прявязан код
   */
  roomNumber: string
}
/**
 * Ошибка кода
 */
export type CodeErrorRequestDto = {
  /**
   * Идентификатор кода
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер помещения к которому прявязан код
   */
  roomNumber: string
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Ошибка кода
 */
export type CodeErrorResponseDto = {
  /**
   * Идентификатор кода
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер помещения к которому прявязан код
   */
  roomNumber: string
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Результат задачи на конфигурирование устройства.
 * Очередь key.device.configure_device_result
 */
export type ConfigureDeviceResultTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата конфигурации устройства
   */
  configuredAt: string
  /**
   * Аппаратная версия
   */
  hardwareVersion?: string
  /**
   * Версия прошивки
   */
  firmwareVersion?: string
  /**
   * Модель
   */
  model: string
  /**
   * Результат настроек
   */
  settings?: ConfigureDeviceResultTaskSettingsRequestDto | null
}
/**
 * Результат задачи на конфигурирование устройства.
 * Очередь key.device.configure_device_result
 */
export type ConfigureDeviceResultTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата конфигурации устройства
   */
  configuredAt: string
  /**
   * Аппаратная версия
   */
  hardwareVersion: string
  /**
   * Версия прошивки
   */
  firmwareVersion: string
  /**
   * Модель
   */
  model: string
  /**
   * Результат настроек
   */
  settings: ConfigureDeviceResultTaskSettingsResponseDto | null
}
/**
 * Результат конфигурации устройства
 */
export type ConfigureDeviceResultTaskSettingsRequestDto = {
  /**
   * Установка пресета
   */
  preset: ConfigureDeviceResultTaskSettingsStateRequestDto
  /**
   * Настройка SIP-аккаунта
   */
  sipAccount?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка сип-номеров в помещениях
   */
  sipRooms?: ConfigureDeviceResultTaskSettingsSipRoomsRequestDto | null
  /**
   * Настройка калитки
   */
  gate?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка ключей
   */
  rfids?: ConfigureDeviceResultTaskSettingsRfidsRequestDto | null
  /**
   * Настройка кодов
   */
  codes?: ConfigureDeviceResultTaskSettingsCodesRequestDto | null
  /**
   * Настройка sl3
   */
  sl3?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
}
/**
 * Результат конфигурации устройства
 */
export type ConfigureDeviceResultTaskSettingsResponseDto = {
  /**
   * Установка пресета
   */
  preset: ConfigureDeviceResultTaskSettingsStateResponseDto
  /**
   * Настройка SIP-аккаунта
   */
  sipAccount: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка сип-номеров в помещениях
   */
  sipRooms: ConfigureDeviceResultTaskSettingsSipRoomsResponseDto | null
  /**
   * Настройка калитки
   */
  gate: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка ключей
   */
  rfids: ConfigureDeviceResultTaskSettingsRfidsResponseDto | null
  /**
   * Настройка кодов
   */
  codes: ConfigureDeviceResultTaskSettingsCodesResponseDto | null
  /**
   * Настройка sl3
   */
  sl3: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings: ConfigureDeviceResultTaskSettingsStateResponseDto | null
}
/**
 * Настройка кодов
 */
export type ConfigureDeviceResultTaskSettingsCodesRequestDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType?: ConfigureDeviceResultTaskSettingsStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Текст ошибки
   */
  errorMessage?: string
  /**
   * Загруженные коды
   */
  loadedCodes?: CodeRequestDto[]
  /**
   * Незагруженные коды
   */
  unloadedCodes?: CodeErrorRequestDto[]
}
/**
 * Настройка кодов
 */
export type ConfigureDeviceResultTaskSettingsCodesResponseDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType: ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Загруженные коды
   */
  loadedCodes: CodeResponseDto[]
  /**
   * Незагруженные коды
   */
  unloadedCodes: CodeErrorResponseDto[]
}
/**
 * Настройка ключей
 */
export type ConfigureDeviceResultTaskSettingsRfidsRequestDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType?: ConfigureDeviceResultTaskSettingsStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Текст ошибки
   */
  errorMessage?: string
  /**
   * Загруженные ключи
   */
  loadedRfids?: RfidRequestDto[]
  /**
   * Незагруженные ключи
   */
  unloadedRfids?: RfidErrorRequestDto[]
}
/**
 * Настройка ключей
 */
export type ConfigureDeviceResultTaskSettingsRfidsResponseDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType: ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Загруженные ключи
   */
  loadedRfids: RfidResponseDto[]
  /**
   * Незагруженные ключи
   */
  unloadedRfids: RfidErrorResponseDto[]
}
/**
 * Настройка квартир
 */
export type ConfigureDeviceResultTaskSettingsSipRoomsRequestDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType?: ConfigureDeviceResultTaskSettingsStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Текст ошибки
   */
  errorMessage?: string
  /**
   * Загруженные квартиры
   */
  loadedSipRooms?: SipRoomRequestDto[]
  /**
   * Незагруженные квартиры
   */
  unloadedSipRooms?: SipRoomErrorRequestDto[]
}
/**
 * Настройка квартир
 */
export type ConfigureDeviceResultTaskSettingsSipRoomsResponseDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType: ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum
  /**
   * Текст ошибки
   */
  errorMessage: string
  /**
   * Загруженные квартиры
   */
  loadedSipRooms: SipRoomResponseDto[]
  /**
   * Незагруженные квартиры
   */
  unloadedSipRooms: SipRoomErrorResponseDto[]
}
/**
 * Состояние настройки
 */
export type ConfigureDeviceResultTaskSettingsStateRequestDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType: ConfigureDeviceResultTaskSettingsStatusTypeRequestEnum
  /**
   * Текст ошибки
   */
  errorMessage?: string
}
/**
 * Состояние настройки
 */
export type ConfigureDeviceResultTaskSettingsStateResponseDto = {
  /**
   * Статус конфигурации устройства
   */
  statusType: ConfigureDeviceResultTaskSettingsStatusTypeResponseEnum
  /**
   * Текст ошибки
   */
  errorMessage: string
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.device.configure_device
 */
export type ConfigureDeviceTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Пресет устройства
   */
  preset: deviceV1.PresetRequestDto
  /**
   * Sip аккаунт
   */
  sipAccount?: ConfigureDeviceTaskSipAccountRequestDto | null
  /**
   * Список сип-номеров в помещениях.
   * # Диапазон: 0..10000
   */
  sipRooms?: SipRoomRequestDto[]
  /**
   * Параметры калитки
   */
  gate?: ConfigureDeviceTaskGateRequestDto | null
  /**
   * Ключи
   */
  rfids?: RfidRequestDto[]
  /**
   * Коды
   */
  codes?: CodeRequestDto[]
  /**
   * Таймзона NTP
   */
  ntpTimezone: string
  /**
   * Параметр Sl3
   */
  sl3?: ConfigureDeviceTaskSl3RequestDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings?: EmergencyCallSettingsRequestDto | null
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.device.configure_device
 */
export type ConfigureDeviceTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Пресет устройства
   */
  preset: deviceV1.PresetResponseDto
  /**
   * Sip аккаунт
   */
  sipAccount: ConfigureDeviceTaskSipAccountResponseDto | null
  /**
   * Список сип-номеров в помещениях.
   * # Диапазон: 0..10000
   */
  sipRooms: SipRoomResponseDto[]
  /**
   * Параметры калитки
   */
  gate: ConfigureDeviceTaskGateResponseDto | null
  /**
   * Ключи
   */
  rfids: RfidResponseDto[]
  /**
   * Коды
   */
  codes: CodeResponseDto[]
  /**
   * Таймзона NTP
   */
  ntpTimezone: string
  /**
   * Параметр Sl3
   */
  sl3: ConfigureDeviceTaskSl3ResponseDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings: EmergencyCallSettingsResponseDto | null
}
/**
 * Профиль шифрования
 */
export type ConfigureDeviceTaskEncryptionProfileRequestDto = {
  /**
   * Номер сектора
   */
  sectorNumber: number
  /**
   * Номер блока
   */
  blockNumber: number
  /**
   * aes ключ
   */
  aesKey: string
  /**
   * Индекс первого символа для секрета
   */
  startIndex?: number
  /**
   * Индекс последнего символа для секрета
   */
  endIndex?: number
}
/**
 * Профиль шифрования
 */
export type ConfigureDeviceTaskEncryptionProfileResponseDto = {
  /**
   * Номер сектора
   */
  sectorNumber: number
  /**
   * Номер блока
   */
  blockNumber: number
  /**
   * aes ключ
   */
  aesKey: string
  /**
   * Индекс первого символа для секрета
   */
  startIndex: number
  /**
   * Индекс последнего символа для секрета
   */
  endIndex: number
}
/**
 * Параметры калитки
 */
export type ConfigureDeviceTaskGateRequestDto = {
  /**
   * Состояние параметра калитки.
   * true - используется, необходимо настроить параметы.
   * false - не используется, необходимо выключить параметры калитки
   */
  isActive: boolean
  /**
   * Параметры реле
   */
  relaySettings: ConfigureDeviceTaskGateRelaySettingsRequestDto[]
  /**
   * Диапазоны квартир
   */
  roomRanges: ConfigureDeviceTaskGateRoomRangeRequestDto[]
}
/**
 * Параметры калитки
 */
export type ConfigureDeviceTaskGateResponseDto = {
  /**
   * Состояние параметра калитки.
   * true - используется, необходимо настроить параметы.
   * false - не используется, необходимо выключить параметры калитки
   */
  isActive: boolean
  /**
   * Параметры реле
   */
  relaySettings: ConfigureDeviceTaskGateRelaySettingsResponseDto[]
  /**
   * Диапазоны квартир
   */
  roomRanges: ConfigureDeviceTaskGateRoomRangeResponseDto[]
}
/**
 * Параметры реле
 */
export type ConfigureDeviceTaskGateRelaySettingsRequestDto = {
  /**
   * Состояние реле.
   * true - по команде «Открыть дверь» произойдет открытие реле.
   * false - по команде «Открыть дверь» не произойдет открытие реле
   */
  isActive: boolean
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex?: number
}
/**
 * Параметры реле
 */
export type ConfigureDeviceTaskGateRelaySettingsResponseDto = {
  /**
   * Состояние реле.
   * true - по команде «Открыть дверь» произойдет открытие реле.
   * false - по команде «Открыть дверь» не произойдет открытие реле
   */
  isActive: boolean
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex: number
}
/**
 * Диапазон квартир
 */
export type ConfigureDeviceTaskGateRoomRangeRequestDto = {
  /**
   * Адрес дома
   */
  address: string
  /**
   * Номер дома (подъезда)
   */
  prefix: string
  /**
   * Начало диапазона включительно
   */
  firstRoomNumber: string
  /**
   * Конец диапазона включительно
   */
  lastRoomNumber: string
}
/**
 * Диапазон квартир
 */
export type ConfigureDeviceTaskGateRoomRangeResponseDto = {
  /**
   * Адрес дома
   */
  address: string
  /**
   * Номер дома (подъезда)
   */
  prefix: string
  /**
   * Начало диапазона включительно
   */
  firstRoomNumber: string
  /**
   * Конец диапазона включительно
   */
  lastRoomNumber: string
}
/**
 * Sip аккаунт
 */
export type ConfigureDeviceTaskSipAccountRequestDto = {
  /**
   * Имя
   */
  name: string
  /**
   * Номер
   */
  number: string
  /**
   * Имя пользователя
   */
  user: string
  /**
   * Пароль
   */
  password: string
}
/**
 * Sip аккаунт
 */
export type ConfigureDeviceTaskSipAccountResponseDto = {
  /**
   * Имя
   */
  name: string
  /**
   * Номер
   */
  number: string
  /**
   * Имя пользователя
   */
  user: string
  /**
   * Пароль
   */
  password: string
}
/**
 * Параметр Sl3
 */
export type ConfigureDeviceTaskSl3RequestDto = {
  /**
   * Статус настройки SL3
   */
  isEnabled: boolean
  /**
   * Профиль шифрования
   */
  encryptionProfile?: ConfigureDeviceTaskEncryptionProfileRequestDto | null
}
/**
 * Параметр Sl3
 */
export type ConfigureDeviceTaskSl3ResponseDto = {
  /**
   * Статус настройки SL3
   */
  isEnabled: boolean
  /**
   * Профиль шифрования
   */
  encryptionProfile: ConfigureDeviceTaskEncryptionProfileResponseDto | null
}
/**
 * Результат задачи на конфигурирование устройства.
 * Очередь key.device.control_device_result
 */
export type ControlDeviceResultTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата конфигурации устройства
   */
  configuredAt: string
  /**
   * Аппаратная версия
   */
  hardwareVersion?: string
  /**
   * Версия прошивки
   */
  firmwareVersion?: string
  /**
   * Модель
   */
  model: string
  /**
   * Результат настроек
   */
  settings?: ControlDeviceResultTaskSettingsRequestDto | null
}
/**
 * Результат задачи на конфигурирование устройства.
 * Очередь key.device.control_device_result
 */
export type ControlDeviceResultTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата конфигурации устройства
   */
  configuredAt: string
  /**
   * Аппаратная версия
   */
  hardwareVersion: string
  /**
   * Версия прошивки
   */
  firmwareVersion: string
  /**
   * Модель
   */
  model: string
  /**
   * Результат настроек
   */
  settings: ControlDeviceResultTaskSettingsResponseDto | null
}
/**
 * Результат конфигурации устройства
 */
export type ControlDeviceResultTaskSettingsRequestDto = {
  /**
   * Настройка распознавания лиц
   */
  faceRecognition?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Установка пресета
   */
  preset?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка SIP-аккаунта
   */
  sipAccount?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка калитки
   */
  gate?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка автосбора
   */
  autocollect?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка консьержа
   */
  concierge?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройка sl3
   */
  sl3?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings?: ConfigureDeviceResultTaskSettingsStateRequestDto | null
}
/**
 * Результат конфигурации устройства
 */
export type ControlDeviceResultTaskSettingsResponseDto = {
  /**
   * Настройка распознавания лиц
   */
  faceRecognition: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Установка пресета
   */
  preset: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка SIP-аккаунта
   */
  sipAccount: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка калитки
   */
  gate: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка автосбора
   */
  autocollect: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка консьержа
   */
  concierge: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройка sl3
   */
  sl3: ConfigureDeviceResultTaskSettingsStateResponseDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings: ConfigureDeviceResultTaskSettingsStateResponseDto | null
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.device.control_device
 */
export type ControlDeviceTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Распознование лиц
   */
  faceRecognition?: ControlDeviceTaskFaceRecognitionRequestDto | null
  /**
   * Пресет устройства
   */
  preset?: deviceV1.PresetRequestDto | null
  /**
   * Таймзона NTP
   */
  ntpTimezone?: string | null
  /**
   * Sip аккаунт
   */
  sipAccount?: ConfigureDeviceTaskSipAccountRequestDto | null
  /**
   * Параметры калитки
   */
  gate?: ConfigureDeviceTaskGateRequestDto | null
  /**
   * Консьерж
   */
  concierge?: ControlDeviceTaskConciergeRequestDto | null
  /**
   * Автосбор
   */
  autocollect?: ControlDeviceTaskAutocollectRequestDto | null
  /**
   * Параметр sl3
   */
  sl3?: ConfigureDeviceTaskSl3RequestDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings?: EmergencyCallSettingsRequestDto | null
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.device.control_device
 */
export type ControlDeviceTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Распознование лиц
   */
  faceRecognition: ControlDeviceTaskFaceRecognitionResponseDto | null
  /**
   * Пресет устройства
   */
  preset: deviceV1.PresetResponseDto | null
  /**
   * Таймзона NTP
   */
  ntpTimezone: string | null
  /**
   * Sip аккаунт
   */
  sipAccount: ConfigureDeviceTaskSipAccountResponseDto | null
  /**
   * Параметры калитки
   */
  gate: ConfigureDeviceTaskGateResponseDto | null
  /**
   * Консьерж
   */
  concierge: ControlDeviceTaskConciergeResponseDto | null
  /**
   * Автосбор
   */
  autocollect: ControlDeviceTaskAutocollectResponseDto | null
  /**
   * Параметр sl3
   */
  sl3: ConfigureDeviceTaskSl3ResponseDto | null
  /**
   * Настройки вызова экстренной службы
   */
  emergencyCallSettings: EmergencyCallSettingsResponseDto | null
}
/**
 * Автосбор
 */
export type ControlDeviceTaskAutocollectRequestDto = {
  /**
   * Статус настройки автосбор
   */
  isEnabled: boolean
}
/**
 * Автосбор
 */
export type ControlDeviceTaskAutocollectResponseDto = {
  /**
   * Статус настройки автосбор
   */
  isEnabled: boolean
}
/**
 * Консьерж
 */
export type ControlDeviceTaskConciergeRequestDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: number
}
/**
 * Консьерж
 */
export type ControlDeviceTaskConciergeResponseDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: number
}
/**
 * Распознование лиц
 */
export type ControlDeviceTaskFaceRecognitionRequestDto = {
  /**
   * Статус настройки распознавания лиц
   */
  isEnabled: boolean
}
/**
 * Распознование лиц
 */
export type ControlDeviceTaskFaceRecognitionResponseDto = {
  /**
   * Статус настройки распознавания лиц
   */
  isEnabled: boolean
}
/**
 * Задача на создание доступа к устройству.
 * Очередь key.device.create_device_access
 */
export type CreateDeviceAccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы устройства.
   * # Диапазон: 0..2147483647
   */
  deviceIds: number[]
  /**
   * Тип субъекта доступа
   */
  deviceAccessAccessorType: accessV1.DeviceAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Задача на создание доступа к устройству.
 * Очередь key.device.create_device_access
 */
export type CreateDeviceAccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы устройства.
   * # Диапазон: 0..2147483647
   */
  deviceIds: number[]
  /**
   * Тип субъекта доступа
   */
  deviceAccessAccessorType: accessV1.DeviceAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Задача ответ на неуспешное удаление кодов с устройства.
 * Очередь key.device.delete_codes_fail
 */
export type DeleteCodesFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки кодов
   */
  codeErrors: CodeErrorRequestDto[]
}
/**
 * Задача ответ на неуспешное удаление кодов с устройства.
 * Очередь key.device.delete_codes_fail
 */
export type DeleteCodesFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки кодов
   */
  codeErrors: CodeErrorResponseDto[]
}
/**
 * Задача ответ на успешное удаление кодов с устройства.
 * Очередь key.device.delete_codes_success
 */
export type DeleteCodesSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * коды
   */
  codes: CodeRequestDto[]
}
/**
 * Задача ответ на успешное удаление кодов с устройства.
 * Очередь key.device.delete_codes_success
 */
export type DeleteCodesSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * коды
   */
  codes: CodeResponseDto[]
}
/**
 * Задача на удаление кодов с устройства.
 * Очередь key.device.delete_codes
 */
export type DeleteCodesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  codes: CodeRequestDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary?: boolean | null
}
/**
 * Задача на удаление кодов с устройства.
 * Очередь key.device.delete_codes
 */
export type DeleteCodesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  codes: CodeResponseDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary: boolean | null
}
/**
 * Задача на удаление доступа к устройству.
 * Очередь key.device.delete_device_access
 */
export type DeleteDeviceAccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы устройства.
   * # Диапазон: 0..2147483647
   */
  deviceIds: number[]
  /**
   * Тип субъекта доступа
   */
  deviceAccessAccessorType: accessV1.DeviceAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Задача на удаление доступа к устройству.
 * Очередь key.device.delete_device_access
 */
export type DeleteDeviceAccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификаторы устройства.
   * # Диапазон: 0..2147483647
   */
  deviceIds: number[]
  /**
   * Тип субъекта доступа
   */
  deviceAccessAccessorType: accessV1.DeviceAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Задача ответ на неуспешное удаление ключей с устройства.
 * Очередь key.device.delete_rfids_fail
 */
export type DeleteRfidsFailTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки ключей
   */
  rfidErrors: RfidErrorRequestDto[]
}
/**
 * Задача ответ на неуспешное удаление ключей с устройства.
 * Очередь key.device.delete_rfids_fail
 */
export type DeleteRfidsFailTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ошибки ключей
   */
  rfidErrors: RfidErrorResponseDto[]
}
/**
 * Задача ответ на успешное удаление ключей с устройства.
 * Очередь key.device.delete_rfids_success
 */
export type DeleteRfidsSuccessTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidRequestDto[]
}
/**
 * Задача ответ на успешное удаление ключей с устройства.
 * Очередь key.device.delete_rfids_success
 */
export type DeleteRfidsSuccessTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidResponseDto[]
}
/**
 * Задача на удаление ключей с устройства.
 * Очередь key.device.delete_rfids
 */
export type DeleteRfidsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidRequestDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary?: boolean | null
}
/**
 * Задача на удаление ключей с устройства.
 * Очередь key.device.delete_rfids
 */
export type DeleteRfidsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  rfids: RfidResponseDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary: boolean | null
}
/**
 * Задача на удаление sip-аккаунта.
 * Очередь key.device.delete_sip_account
 */
export type DeleteSipAccountTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата и время удаления устройства
   */
  deletedAt: string
  /**
   * Sip-login устройства
   */
  sipLogin: string
}
/**
 * Задача на удаление sip-аккаунта.
 * Очередь key.device.delete_sip_account
 */
export type DeleteSipAccountTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Дата и время удаления устройства
   */
  deletedAt: string
  /**
   * Sip-login устройства
   */
  sipLogin: string
}
/**
 * Задача на удаление Sl3 ключей с устройства.
 * Очередь key.device.delete_sl3_rfids
 */
export type DeleteSl3RfidsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  sl3Rfids: DeleteSl3RfidsTaskSl3RfidRequestDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary?: boolean | null
}
/**
 * Задача на удаление Sl3 ключей с устройства.
 * Очередь key.device.delete_sl3_rfids
 */
export type DeleteSl3RfidsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Ключи
   */
  sl3Rfids: DeleteSl3RfidsTaskSl3RfidResponseDto[]
  /**
   * При передаче этого флага в true, ответное сообщение не будет получено
   */
  isAnswerUnnecessary: boolean | null
}
/**
 * Ключ sl3
 */
export type DeleteSl3RfidsTaskSl3RfidRequestDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Значение ключа
   */
  key: string
  /**
   * Секрет
   */
  keySecret: string
}
/**
 * Ключ sl3
 */
export type DeleteSl3RfidsTaskSl3RfidResponseDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Значение ключа
   */
  key: string
  /**
   * Секрет
   */
  keySecret: string
}
/**
 * Настройки вызова экстренной службы
 */
export type EmergencyCallSettingsRequestDto = {
  /**
   * Возможность вызова экстренной службы
   */
  isCallAvailable?: boolean
  /**
   * Параметры вызова экстренной службы
   */
  emergencyCallParameter?: EmergencyCallSettingsEmergencyCallParameterRequestDto | null
}
/**
 * Настройки вызова экстренной службы
 */
export type EmergencyCallSettingsResponseDto = {
  /**
   * Возможность вызова экстренной службы
   */
  isCallAvailable: boolean
  /**
   * Параметры вызова экстренной службы
   */
  emergencyCallParameter: EmergencyCallSettingsEmergencyCallParameterResponseDto | null
}
/**
 * Параметры вызова экстренной службы
 */
export type EmergencyCallSettingsEmergencyCallParameterRequestDto = {
  /**
   * АБС-номер экстренной службы.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  emergencyNumber: string
  /**
   * Исходящий ABC-номер домофона.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  abcNumber: string
  /**
   * Адрес SIP-транка.
   * # Диапазон: 5..250
   */
  sipTrunkHost: string
  /**
   * Регион вызова экстренной службы.
   * # Диапазон: 3..32
   */
  destinationName: string
}
/**
 * Параметры вызова экстренной службы
 */
export type EmergencyCallSettingsEmergencyCallParameterResponseDto = {
  /**
   * АБС-номер экстренной службы.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  emergencyNumber: string
  /**
   * Исходящий ABC-номер домофона.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  abcNumber: string
  /**
   * Адрес SIP-транка.
   * # Диапазон: 5..250
   */
  sipTrunkHost: string
  /**
   * Регион вызова экстренной службы.
   * # Диапазон: 3..32
   */
  destinationName: string
}
/**
 * Задача на открытие точки доступа.
 * Очередь key.device.open_access_point
 */
export type OpenAccessPointTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номер реле
   */
  relayIndex?: number | null
  /**
   * Задержка в секундах
   */
  delay?: number | null
  /**
   * ГРЗ авто
   */
  carNumber?: string | null
  /**
   * Тип ТС
   */
  vehicle?: string | null
  /**
   * Наименование курьерской компании
   */
  courierCompanyName?: string | null
  /**
   * Номер заказа
   */
  orderNumber?: string | null
  /**
   * Идентификатор курьера
   */
  courierId?: string | null
}
/**
 * Задача на открытие точки доступа.
 * Очередь key.device.open_access_point
 */
export type OpenAccessPointTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номер реле
   */
  relayIndex: number | null
  /**
   * Задержка в секундах
   */
  delay: number | null
  /**
   * ГРЗ авто
   */
  carNumber: string | null
  /**
   * Тип ТС
   */
  vehicle: string | null
  /**
   * Наименование курьерской компании
   */
  courierCompanyName: string | null
  /**
   * Номер заказа
   */
  orderNumber: string | null
  /**
   * Идентификатор курьера
   */
  courierId: string | null
}
/**
 * Задача на открытие устройства.
 * Очередь key.device.open
 */
export type OpenTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username?: string
  /**
   * Пароль
   */
  password?: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номер реле
   */
  relayIndex?: number | null
  /**
   * Задержка в секундах.
   * Если не передано, то полставляется значение по умолчанию (5)
   */
  delay?: number | null
}
/**
 * Задача на открытие устройства.
 * Очередь key.device.open
 */
export type OpenTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Модель
   */
  model: string
  /**
   * Хост
   */
  host: string
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль
   */
  password: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номер реле
   */
  relayIndex: number | null
  /**
   * Задержка в секундах.
   * Если не передано, то полставляется значение по умолчанию (5)
   */
  delay: number | null
}
/**
 * Ключ
 */
export type RfidRequestDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
}
/**
 * Ключ
 */
export type RfidResponseDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
}
/**
 * Ошибка ключа
 */
export type RfidErrorRequestDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Ошибка ключа
 */
export type RfidErrorResponseDto = {
  /**
   * Идентификатор ключа
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер помещения к которому прявязан ключ
   */
  roomNumber: string
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Сип-номер в помещении
 */
export type SipRoomRequestDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: string
  /**
   * Идентификатор квартиры.
   * # Диапазон: 1..2147483647
   */
  roomId: number
}
/**
 * Сип-номер в помещении
 */
export type SipRoomResponseDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: string
  /**
   * Идентификатор квартиры.
   * # Диапазон: 1..2147483647
   */
  roomId: number
}
/**
 * Ошибка сип-номера в помещении
 */
export type SipRoomErrorRequestDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: string
  /**
   * Идентификатор квартиры.
   * # Диапазон: 1..2147483647
   */
  roomId: number
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Ошибка сип-номера в помещении
 */
export type SipRoomErrorResponseDto = {
  /**
   * Номер сип-трубки.
   * # Диапазон: 5..14
   */
  sipNumber: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  roomNumber: string
  /**
   * Идентификатор квартиры.
   * # Диапазон: 1..2147483647
   */
  roomId: number
  /**
   * Сообщение об ошибке
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача ответ на ошибку при разблокировке аналоговой трубки на устройстве для квартиры.
   * Очередь key.device.cms_phone_activate_fail
   */
  "ActivateCmsPhoneFailTask": {
    "kind": "class",
    "text": "Задача ответ на ошибку при разблокировке аналоговой трубки на устройстве для квартиры.\nОчередь key.device.cms_phone_activate_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор аналоговой трубки
       */
      "cmsPhoneId": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время события
       */
      "occuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время события",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешную разблокировку аналоговой трубки на устройстве для квартиры.
   * Очередь key.device.cms_phone_activate_success
   */
  "ActivateCmsPhoneSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешную разблокировку аналоговой трубки на устройстве для квартиры.\nОчередь key.device.cms_phone_activate_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор аналоговой трубки
       */
      "cmsPhoneId": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время разблокировки аналоговой трубки
       */
      "activatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время разблокировки аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача разблокировку аналоговых трубок на устройстве для квартир.
   * Очередь key.device.cms_phones_activate
   */
  "ActivateCmsPhonesTask": {
    "kind": "class",
    "text": "Задача разблокировку аналоговых трубок на устройстве для квартир.\nОчередь key.device.cms_phones_activate",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Список аналоговых трубок
       */
      "cmsPhones": {
        "type": "ActivateCmsPhonesTask.CmsPhone",
        "text": "Список аналоговых трубок",
      },
    },
  },
  /**
   * Аналоговая трубка
   */
  "ActivateCmsPhonesTask.CmsPhone": {
    "kind": "class",
    "text": "Аналоговая трубка",
    "fields": {
      /**
       * Идентификатор аналоговой трубки
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на неуспешное на добавление кодов на устройство.
   * Очередь key.device.add_codes_fail
   */
  "AddCodesFailTask": {
    "kind": "class",
    "text": "Задача ответ на неуспешное на добавление кодов на устройство.\nОчередь key.device.add_codes_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибки кодов
       */
      "codeErrors": {
        "type": "CodeError",
        "text": "Ошибки кодов",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешное на добавление кодов на устройство.
   * Очередь key.device.add_codes_success
   */
  "AddCodesSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешное на добавление кодов на устройство.\nОчередь key.device.add_codes_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * коды
       */
      "codes": {
        "type": "Code",
        "text": "коды",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на добавление кодов на устройство.
   * Очередь key.device.add_codes
   */
  "AddCodesTask": {
    "kind": "class",
    "text": "Задача на добавление кодов на устройство.\nОчередь key.device.add_codes",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "codes": {
        "type": "Code",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на неуспешное на добавление ключей на устройство.
   * Очередь key.device.add_rfids_fail
   */
  "AddRfidsFailTask": {
    "kind": "class",
    "text": "Задача ответ на неуспешное на добавление ключей на устройство.\nОчередь key.device.add_rfids_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибки ключей
       */
      "rfidErrors": {
        "type": "RfidError",
        "text": "Ошибки ключей",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешное на добавление ключей на устройство.
   * Очередь key.device.add_rfids_success
   */
  "AddRfidsSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешное на добавление ключей на устройство.\nОчередь key.device.add_rfids_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "rfids": {
        "type": "Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на добавление ключей на устройство.
   * Очередь key.device.add_rfids
   */
  "AddRfidsTask": {
    "kind": "class",
    "text": "Задача на добавление ключей на устройство.\nОчередь key.device.add_rfids",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "rfids": {
        "type": "Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на добавление Sl3 ключей на устройство.
   * Очередь key.device.add_sl3_rfids
   */
  "AddSl3RfidsTask": {
    "kind": "class",
    "text": "Задача на добавление Sl3 ключей на устройство.\nОчередь key.device.add_sl3_rfids",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "sl3Rfids": {
        "type": "AddSl3RfidsTask.Sl3Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ключ sl3
   */
  "AddSl3RfidsTask.Sl3Rfid": {
    "kind": "class",
    "text": "Ключ sl3",
    "fields": {
      /**
       * Идентификатор ключа
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан ключ
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Секрет
       */
      "keySecret": {
        "type": "string",
        "text": "Секрет",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на ошибку при блокировке аналоговой трубки на устройстве для квартиры.
   * Очередь key.device.cms_phone_block_fail
   */
  "BlockCmsPhoneFailTask": {
    "kind": "class",
    "text": "Задача ответ на ошибку при блокировке аналоговой трубки на устройстве для квартиры.\nОчередь key.device.cms_phone_block_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор аналоговой трубки
       */
      "cmsPhoneId": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время события
       */
      "occuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время события",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешную блокировку аналоговой трубки на устройстве для квартиры.
   * Очередь key.device.cms_phone_block_success
   */
  "BlockCmsPhoneSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешную блокировку аналоговой трубки на устройстве для квартиры.\nОчередь key.device.cms_phone_block_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор аналоговой трубки
       */
      "cmsPhoneId": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время блокировки аналоговой трубки
       */
      "blockedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время блокировки аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на блокировку аналоговых трубок на устройствах для квартир.
   * Очередь key.device.cms_phones_block
   */
  "BlockCmsPhonesTask": {
    "kind": "class",
    "text": "Задача на блокировку аналоговых трубок на устройствах для квартир.\nОчередь key.device.cms_phones_block",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Список аналоговых трубок
       */
      "cmsPhones": {
        "type": "BlockCmsPhonesTask.CmsPhone",
        "text": "Список аналоговых трубок",
      },
    },
  },
  /**
   * Аналоговая трубка
   */
  "BlockCmsPhonesTask.CmsPhone": {
    "kind": "class",
    "text": "Аналоговая трубка",
    "fields": {
      /**
       * Идентификатор аналоговой трубки
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Сообщение о появлении возможности работы с аналоговыми трубками на устройстве.
   * Очередь key.device.device_cms_available
   */
  "CmsAvailableTask": {
    "kind": "class",
    "text": "Сообщение о появлении возможности работы с аналоговыми трубками на устройстве.\nОчередь key.device.device_cms_available",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на использование аналоговых трубок.
   * Очередь key.device.cms_available
   */
  "CmsServiceAvailableTask": {
    "kind": "class",
    "text": "Задача на использование аналоговых трубок.\nОчередь key.device.cms_available",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Код
   */
  "Code": {
    "kind": "class",
    "text": "Код",
    "fields": {
      /**
       * Идентификатор кода
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение кода
       */
      "code": {
        "type": "string",
        "text": "Значение кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан код
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан код",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка кода
   */
  "CodeError": {
    "kind": "class",
    "text": "Ошибка кода",
    "fields": {
      /**
       * Идентификатор кода
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение кода
       */
      "code": {
        "type": "string",
        "text": "Значение кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан код
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан код",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сообщение об ошибке
       */
      "message": {
        "type": "string",
        "text": "Сообщение об ошибке",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат задачи на конфигурирование устройства.
   * Очередь key.device.configure_device_result
   */
  "ConfigureDeviceResultTask": {
    "kind": "class",
    "text": "Результат задачи на конфигурирование устройства.\nОчередь key.device.configure_device_result",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата конфигурации устройства
       */
      "configuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата конфигурации устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Аппаратная версия
       */
      "hardwareVersion": {
        "type": "string",
        "text": "Аппаратная версия",
      },
      /**
       * Версия прошивки
       */
      "firmwareVersion": {
        "type": "string",
        "text": "Версия прошивки",
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Результат настроек
       */
      "settings": {
        "type": "ConfigureDeviceResultTask.Settings",
        "text": "Результат настроек",
      },
    },
  },
  /**
   * Результат конфигурации устройства
   */
  "ConfigureDeviceResultTask.Settings": {
    "kind": "class",
    "text": "Результат конфигурации устройства",
    "fields": {
      /**
       * Установка пресета
       */
      "preset": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Установка пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Настройка SIP-аккаунта
       */
      "sipAccount": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка SIP-аккаунта",
      },
      /**
       * Настройка сип-номеров в помещениях
       */
      "sipRooms": {
        "type": "ConfigureDeviceResultTask.Settings.SipRooms",
        "text": "Настройка сип-номеров в помещениях",
      },
      /**
       * Настройка калитки
       */
      "gate": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка калитки",
      },
      /**
       * Настройка ключей
       */
      "rfids": {
        "type": "ConfigureDeviceResultTask.Settings.Rfids",
        "text": "Настройка ключей",
      },
      /**
       * Настройка кодов
       */
      "codes": {
        "type": "ConfigureDeviceResultTask.Settings.Codes",
        "text": "Настройка кодов",
      },
      /**
       * Настройка sl3
       */
      "sl3": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка sl3",
      },
      /**
       * Настройки вызова экстренной службы
       */
      "emergencyCallSettings": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройки вызова экстренной службы",
      },
    },
  },
  /**
   * Настройка кодов
   */
  "ConfigureDeviceResultTask.Settings.Codes": {
    "kind": "class",
    "text": "Настройка кодов",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "statusType": {
        "type": "ConfigureDeviceResultTask.Settings.StatusType",
        "text": "Статус конфигурации устройства",
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
      },
      /**
       * Загруженные коды
       */
      "loadedCodes": {
        "type": "Code",
        "text": "Загруженные коды",
      },
      /**
       * Незагруженные коды
       */
      "unloadedCodes": {
        "type": "CodeError",
        "text": "Незагруженные коды",
      },
    },
  },
  /**
   * Настройка ключей
   */
  "ConfigureDeviceResultTask.Settings.Rfids": {
    "kind": "class",
    "text": "Настройка ключей",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "statusType": {
        "type": "ConfigureDeviceResultTask.Settings.StatusType",
        "text": "Статус конфигурации устройства",
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
      },
      /**
       * Загруженные ключи
       */
      "loadedRfids": {
        "type": "Rfid",
        "text": "Загруженные ключи",
      },
      /**
       * Незагруженные ключи
       */
      "unloadedRfids": {
        "type": "RfidError",
        "text": "Незагруженные ключи",
      },
    },
  },
  /**
   * Настройка квартир
   */
  "ConfigureDeviceResultTask.Settings.SipRooms": {
    "kind": "class",
    "text": "Настройка квартир",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "statusType": {
        "type": "ConfigureDeviceResultTask.Settings.StatusType",
        "text": "Статус конфигурации устройства",
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
      },
      /**
       * Загруженные квартиры
       */
      "loadedSipRooms": {
        "type": "SipRoom",
        "text": "Загруженные квартиры",
      },
      /**
       * Незагруженные квартиры
       */
      "unloadedSipRooms": {
        "type": "SipRoomError",
        "text": "Незагруженные квартиры",
      },
    },
  },
  /**
   * Состояние настройки
   */
  "ConfigureDeviceResultTask.Settings.State": {
    "kind": "class",
    "text": "Состояние настройки",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "statusType": {
        "type": "ConfigureDeviceResultTask.Settings.StatusType",
        "text": "Статус конфигурации устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
      },
    },
  },
  /**
   * Задача на конфигурирование устройства.
   * Очередь key.device.configure_device
   */
  "ConfigureDeviceTask": {
    "kind": "class",
    "text": "Задача на конфигурирование устройства.\nОчередь key.device.configure_device",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес устройства
       */
      "host": {
        "type": "string",
        "text": "Адрес устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя устройства
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль пользователья устройства
       */
      "password": {
        "type": "string",
        "text": "Пароль пользователья устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пресет устройства
       */
      "preset": {
        "type": "Preset",
        "text": "Пресет устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Sip аккаунт
       */
      "sipAccount": {
        "type": "ConfigureDeviceTask.SipAccount",
        "text": "Sip аккаунт",
      },
      /**
       * Список сип-номеров в помещениях.
       * # Диапазон: 0..10000
       */
      "sipRooms": {
        "type": "SipRoom",
        "text": "Список сип-номеров в помещениях.\n# Диапазон: 0..10000",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
      /**
       * Параметры калитки
       */
      "gate": {
        "type": "ConfigureDeviceTask.Gate",
        "text": "Параметры калитки",
      },
      /**
       * Ключи
       */
      "rfids": {
        "type": "Rfid",
        "text": "Ключи",
      },
      /**
       * Коды
       */
      "codes": {
        "type": "Code",
        "text": "Коды",
      },
      /**
       * Таймзона NTP
       */
      "ntpTimezone": {
        "type": "string",
        "text": "Таймзона NTP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр Sl3
       */
      "sl3": {
        "type": "ConfigureDeviceTask.Sl3",
        "text": "Параметр Sl3",
      },
      /**
       * Настройки вызова экстренной службы
       */
      "emergencyCallSettings": {
        "type": "EmergencyCallSettings",
        "text": "Настройки вызова экстренной службы",
      },
    },
  },
  /**
   * Профиль шифрования
   */
  "ConfigureDeviceTask.EncryptionProfile": {
    "kind": "class",
    "text": "Профиль шифрования",
    "fields": {
      /**
       * Номер сектора
       */
      "sectorNumber": {
        "type": "int32",
        "text": "Номер сектора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер блока
       */
      "blockNumber": {
        "type": "int32",
        "text": "Номер блока",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * aes ключ
       */
      "aesKey": {
        "type": "string",
        "text": "aes ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Индекс первого символа для секрета
       */
      "startIndex": {
        "type": "int32",
        "text": "Индекс первого символа для секрета",
      },
      /**
       * Индекс последнего символа для секрета
       */
      "endIndex": {
        "type": "int32",
        "text": "Индекс последнего символа для секрета",
      },
    },
  },
  /**
   * Параметры калитки
   */
  "ConfigureDeviceTask.Gate": {
    "kind": "class",
    "text": "Параметры калитки",
    "fields": {
      /**
       * Состояние параметра калитки.
       * true - используется, необходимо настроить параметы.
       * false - не используется, необходимо выключить параметры калитки
       */
      "isActive": {
        "type": "bool",
        "text": "Состояние параметра калитки.\ntrue - используется, необходимо настроить параметы.\nfalse - не используется, необходимо выключить параметры калитки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметры реле
       */
      "relaySettings": {
        "type": "ConfigureDeviceTask.Gate.RelaySettings",
        "text": "Параметры реле",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Диапазоны квартир
       */
      "roomRanges": {
        "type": "ConfigureDeviceTask.Gate.RoomRange",
        "text": "Диапазоны квартир",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Параметры реле
   */
  "ConfigureDeviceTask.Gate.RelaySettings": {
    "kind": "class",
    "text": "Параметры реле",
    "fields": {
      /**
       * Состояние реле.
       * true - по команде «Открыть дверь» произойдет открытие реле.
       * false - по команде «Открыть дверь» не произойдет открытие реле
       */
      "isActive": {
        "type": "bool",
        "text": "Состояние реле.\ntrue - по команде «Открыть дверь» произойдет открытие реле.\nfalse - по команде «Открыть дверь» не произойдет открытие реле",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Индекс реле.
       * # Диапазон: 0..64
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\n# Диапазон: 0..64",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
    },
  },
  /**
   * Диапазон квартир
   */
  "ConfigureDeviceTask.Gate.RoomRange": {
    "kind": "class",
    "text": "Диапазон квартир",
    "fields": {
      /**
       * Адрес дома
       */
      "address": {
        "type": "string",
        "text": "Адрес дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер дома (подъезда)
       */
      "prefix": {
        "type": "string",
        "text": "Номер дома (подъезда)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Начало диапазона включительно
       */
      "firstRoomNumber": {
        "type": "string",
        "text": "Начало диапазона включительно",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Конец диапазона включительно
       */
      "lastRoomNumber": {
        "type": "string",
        "text": "Конец диапазона включительно",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Sip аккаунт
   */
  "ConfigureDeviceTask.SipAccount": {
    "kind": "class",
    "text": "Sip аккаунт",
    "fields": {
      /**
       * Имя
       */
      "name": {
        "type": "string",
        "text": "Имя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер
       */
      "number": {
        "type": "string",
        "text": "Номер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "user": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Параметр Sl3
   */
  "ConfigureDeviceTask.Sl3": {
    "kind": "class",
    "text": "Параметр Sl3",
    "fields": {
      /**
       * Статус настройки SL3
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки SL3",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Профиль шифрования
       */
      "encryptionProfile": {
        "type": "ConfigureDeviceTask.EncryptionProfile",
        "text": "Профиль шифрования",
      },
    },
  },
  /**
   * Результат задачи на конфигурирование устройства.
   * Очередь key.device.control_device_result
   */
  "ControlDeviceResultTask": {
    "kind": "class",
    "text": "Результат задачи на конфигурирование устройства.\nОчередь key.device.control_device_result",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата конфигурации устройства
       */
      "configuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата конфигурации устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Аппаратная версия
       */
      "hardwareVersion": {
        "type": "string",
        "text": "Аппаратная версия",
      },
      /**
       * Версия прошивки
       */
      "firmwareVersion": {
        "type": "string",
        "text": "Версия прошивки",
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Результат настроек
       */
      "settings": {
        "type": "ControlDeviceResultTask.Settings",
        "text": "Результат настроек",
      },
    },
  },
  /**
   * Результат конфигурации устройства
   */
  "ControlDeviceResultTask.Settings": {
    "kind": "class",
    "text": "Результат конфигурации устройства",
    "fields": {
      /**
       * Настройка распознавания лиц
       */
      "faceRecognition": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка распознавания лиц",
      },
      /**
       * Установка пресета
       */
      "preset": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Установка пресета",
      },
      /**
       * Настройка SIP-аккаунта
       */
      "sipAccount": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка SIP-аккаунта",
      },
      /**
       * Настройка калитки
       */
      "gate": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка калитки",
      },
      /**
       * Настройка автосбора
       */
      "autocollect": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка автосбора",
      },
      /**
       * Настройка консьержа
       */
      "concierge": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка консьержа",
      },
      /**
       * Настройка sl3
       */
      "sl3": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройка sl3",
      },
      /**
       * Настройки вызова экстренной службы
       */
      "emergencyCallSettings": {
        "type": "ConfigureDeviceResultTask.Settings.State",
        "text": "Настройки вызова экстренной службы",
      },
    },
  },
  /**
   * Задача на конфигурирование устройства.
   * Очередь key.device.control_device
   */
  "ControlDeviceTask": {
    "kind": "class",
    "text": "Задача на конфигурирование устройства.\nОчередь key.device.control_device",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес устройства
       */
      "host": {
        "type": "string",
        "text": "Адрес устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя устройства
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль пользователья устройства
       */
      "password": {
        "type": "string",
        "text": "Пароль пользователья устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Распознование лиц
       */
      "faceRecognition": {
        "type": "ControlDeviceTask.FaceRecognition",
        "text": "Распознование лиц",
      },
      /**
       * Пресет устройства
       */
      "preset": {
        "type": "Preset",
        "text": "Пресет устройства",
      },
      /**
       * Таймзона NTP
       */
      "ntpTimezone": {
        "type": "google.protobuf.StringValue",
        "text": "Таймзона NTP",
      },
      /**
       * Sip аккаунт
       */
      "sipAccount": {
        "type": "ConfigureDeviceTask.SipAccount",
        "text": "Sip аккаунт",
      },
      /**
       * Параметры калитки
       */
      "gate": {
        "type": "ConfigureDeviceTask.Gate",
        "text": "Параметры калитки",
      },
      /**
       * Консьерж
       */
      "concierge": {
        "type": "ControlDeviceTask.Concierge",
        "text": "Консьерж",
      },
      /**
       * Автосбор
       */
      "autocollect": {
        "type": "ControlDeviceTask.Autocollect",
        "text": "Автосбор",
      },
      /**
       * Параметр sl3
       */
      "sl3": {
        "type": "ConfigureDeviceTask.Sl3",
        "text": "Параметр sl3",
      },
      /**
       * Настройки вызова экстренной службы
       */
      "emergencyCallSettings": {
        "type": "EmergencyCallSettings",
        "text": "Настройки вызова экстренной службы",
      },
    },
  },
  /**
   * Автосбор
   */
  "ControlDeviceTask.Autocollect": {
    "kind": "class",
    "text": "Автосбор",
    "fields": {
      /**
       * Статус настройки автосбор
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки автосбор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Консьерж
   */
  "ControlDeviceTask.Concierge": {
    "kind": "class",
    "text": "Консьерж",
    "fields": {
      /**
       * Номер сип-трубки.
       * # Диапазон: 5..14
       */
      "sipNumber": {
        "type": "string",
        "text": "Номер сип-трубки.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Номер помещения.
       * # Диапазон: 1..10000
       */
      "roomNumber": {
        "type": "int32",
        "text": "Номер помещения.\n# Диапазон: 1..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
    },
  },
  /**
   * Распознование лиц
   */
  "ControlDeviceTask.FaceRecognition": {
    "kind": "class",
    "text": "Распознование лиц",
    "fields": {
      /**
       * Статус настройки распознавания лиц
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки распознавания лиц",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на создание доступа к устройству.
   * Очередь key.device.create_device_access
   */
  "CreateDeviceAccessTask": {
    "kind": "class",
    "text": "Задача на создание доступа к устройству.\nОчередь key.device.create_device_access",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы устройства.
       * # Диапазон: 0..2147483647
       */
      "deviceIds": {
        "type": "int32",
        "text": "Идентификаторы устройства.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип субъекта доступа
       */
      "deviceAccessAccessorType": {
        "type": "DeviceAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
    },
  },
  /**
   * Задача ответ на неуспешное удаление кодов с устройства.
   * Очередь key.device.delete_codes_fail
   */
  "DeleteCodesFailTask": {
    "kind": "class",
    "text": "Задача ответ на неуспешное удаление кодов с устройства.\nОчередь key.device.delete_codes_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибки кодов
       */
      "codeErrors": {
        "type": "CodeError",
        "text": "Ошибки кодов",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешное удаление кодов с устройства.
   * Очередь key.device.delete_codes_success
   */
  "DeleteCodesSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешное удаление кодов с устройства.\nОчередь key.device.delete_codes_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * коды
       */
      "codes": {
        "type": "Code",
        "text": "коды",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на удаление кодов с устройства.
   * Очередь key.device.delete_codes
   */
  "DeleteCodesTask": {
    "kind": "class",
    "text": "Задача на удаление кодов с устройства.\nОчередь key.device.delete_codes",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "codes": {
        "type": "Code",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * При передаче этого флага в true, ответное сообщение не будет получено
       */
      "isAnswerUnnecessary": {
        "type": "google.protobuf.BoolValue",
        "text": "При передаче этого флага в true, ответное сообщение не будет получено",
      },
    },
  },
  /**
   * Задача на удаление доступа к устройству.
   * Очередь key.device.delete_device_access
   */
  "DeleteDeviceAccessTask": {
    "kind": "class",
    "text": "Задача на удаление доступа к устройству.\nОчередь key.device.delete_device_access",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы устройства.
       * # Диапазон: 0..2147483647
       */
      "deviceIds": {
        "type": "int32",
        "text": "Идентификаторы устройства.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип субъекта доступа
       */
      "deviceAccessAccessorType": {
        "type": "DeviceAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
    },
  },
  /**
   * Задача ответ на неуспешное удаление ключей с устройства.
   * Очередь key.device.delete_rfids_fail
   */
  "DeleteRfidsFailTask": {
    "kind": "class",
    "text": "Задача ответ на неуспешное удаление ключей с устройства.\nОчередь key.device.delete_rfids_fail",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибки ключей
       */
      "rfidErrors": {
        "type": "RfidError",
        "text": "Ошибки ключей",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на успешное удаление ключей с устройства.
   * Очередь key.device.delete_rfids_success
   */
  "DeleteRfidsSuccessTask": {
    "kind": "class",
    "text": "Задача ответ на успешное удаление ключей с устройства.\nОчередь key.device.delete_rfids_success",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "rfids": {
        "type": "Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на удаление ключей с устройства.
   * Очередь key.device.delete_rfids
   */
  "DeleteRfidsTask": {
    "kind": "class",
    "text": "Задача на удаление ключей с устройства.\nОчередь key.device.delete_rfids",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "rfids": {
        "type": "Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * При передаче этого флага в true, ответное сообщение не будет получено
       */
      "isAnswerUnnecessary": {
        "type": "google.protobuf.BoolValue",
        "text": "При передаче этого флага в true, ответное сообщение не будет получено",
      },
    },
  },
  /**
   * Задача на удаление sip-аккаунта.
   * Очередь key.device.delete_sip_account
   */
  "DeleteSipAccountTask": {
    "kind": "class",
    "text": "Задача на удаление sip-аккаунта.\nОчередь key.device.delete_sip_account",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время удаления устройства
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время удаления устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Sip-login устройства
       */
      "sipLogin": {
        "type": "string",
        "text": "Sip-login устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на удаление Sl3 ключей с устройства.
   * Очередь key.device.delete_sl3_rfids
   */
  "DeleteSl3RfidsTask": {
    "kind": "class",
    "text": "Задача на удаление Sl3 ключей с устройства.\nОчередь key.device.delete_sl3_rfids",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ключи
       */
      "sl3Rfids": {
        "type": "DeleteSl3RfidsTask.Sl3Rfid",
        "text": "Ключи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * При передаче этого флага в true, ответное сообщение не будет получено
       */
      "isAnswerUnnecessary": {
        "type": "google.protobuf.BoolValue",
        "text": "При передаче этого флага в true, ответное сообщение не будет получено",
      },
    },
  },
  /**
   * Ключ sl3
   */
  "DeleteSl3RfidsTask.Sl3Rfid": {
    "kind": "class",
    "text": "Ключ sl3",
    "fields": {
      /**
       * Идентификатор ключа
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан ключ
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Секрет
       */
      "keySecret": {
        "type": "string",
        "text": "Секрет",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Настройки вызова экстренной службы
   */
  "EmergencyCallSettings": {
    "kind": "class",
    "text": "Настройки вызова экстренной службы",
    "fields": {
      /**
       * Возможность вызова экстренной службы
       */
      "isCallAvailable": {
        "type": "bool",
        "text": "Возможность вызова экстренной службы",
      },
      /**
       * Параметры вызова экстренной службы
       */
      "emergencyCallParameter": {
        "type": "EmergencyCallSettings.EmergencyCallParameter",
        "text": "Параметры вызова экстренной службы",
      },
    },
  },
  /**
   * Параметры вызова экстренной службы
   */
  "EmergencyCallSettings.EmergencyCallParameter": {
    "kind": "class",
    "text": "Параметры вызова экстренной службы",
    "fields": {
      /**
       * АБС-номер экстренной службы.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "emergencyNumber": {
        "type": "string",
        "text": "АБС-номер экстренной службы.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
      /**
       * Исходящий ABC-номер домофона.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "abcNumber": {
        "type": "string",
        "text": "Исходящий ABC-номер домофона.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
      /**
       * Адрес SIP-транка.
       * # Диапазон: 5..250
       */
      "sipTrunkHost": {
        "type": "string",
        "text": "Адрес SIP-транка.\n# Диапазон: 5..250",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 250,
            "message": "Значение не входит в допустимый диапазон. Максимум: 250"
          },
        }
      },
      /**
       * Регион вызова экстренной службы.
       * # Диапазон: 3..32
       */
      "destinationName": {
        "type": "string",
        "text": "Регион вызова экстренной службы.\n# Диапазон: 3..32",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
    },
  },
  /**
   * Задача на открытие точки доступа.
   * Очередь key.device.open_access_point
   */
  "OpenAccessPointTask": {
    "kind": "class",
    "text": "Задача на открытие точки доступа.\nОчередь key.device.open_access_point",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер реле
       */
      "relayIndex": {
        "type": "google.protobuf.Int32Value",
        "text": "Номер реле",
      },
      /**
       * Задержка в секундах
       */
      "delay": {
        "type": "google.protobuf.Int32Value",
        "text": "Задержка в секундах",
      },
      /**
       * ГРЗ авто
       */
      "carNumber": {
        "type": "google.protobuf.StringValue",
        "text": "ГРЗ авто",
      },
      /**
       * Тип ТС
       */
      "vehicle": {
        "type": "google.protobuf.StringValue",
        "text": "Тип ТС",
      },
      /**
       * Наименование курьерской компании
       */
      "courierCompanyName": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование курьерской компании",
      },
      /**
       * Номер заказа
       */
      "orderNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер заказа",
      },
      /**
       * Идентификатор курьера
       */
      "courierId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор курьера",
      },
    },
  },
  /**
   * Задача на открытие устройства.
   * Очередь key.device.open
   */
  "OpenTask": {
    "kind": "class",
    "text": "Задача на открытие устройства.\nОчередь key.device.open",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
      },
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер реле
       */
      "relayIndex": {
        "type": "google.protobuf.Int32Value",
        "text": "Номер реле",
      },
      /**
       * Задержка в секундах.
       * Если не передано, то полставляется значение по умолчанию (5)
       */
      "delay": {
        "type": "google.protobuf.Int32Value",
        "text": "Задержка в секундах.\nЕсли не передано, то полставляется значение по умолчанию (5)",
      },
    },
  },
  /**
   * Ключ
   */
  "Rfid": {
    "kind": "class",
    "text": "Ключ",
    "fields": {
      /**
       * Идентификатор ключа
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан ключ
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка ключа
   */
  "RfidError": {
    "kind": "class",
    "text": "Ошибка ключа",
    "fields": {
      /**
       * Идентификатор ключа
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер помещения к которому прявязан ключ
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения к которому прявязан ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сообщение об ошибке
       */
      "message": {
        "type": "string",
        "text": "Сообщение об ошибке",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Сип-номер в помещении
   */
  "SipRoom": {
    "kind": "class",
    "text": "Сип-номер в помещении",
    "fields": {
      /**
       * Номер сип-трубки.
       * # Диапазон: 5..14
       */
      "sipNumber": {
        "type": "string",
        "text": "Номер сип-трубки.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Номер помещения.
       * # Диапазон: 1..10000
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения.\n# Диапазон: 1..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
      /**
       * Идентификатор квартиры.
       * # Диапазон: 1..2147483647
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибка сип-номера в помещении
   */
  "SipRoomError": {
    "kind": "class",
    "text": "Ошибка сип-номера в помещении",
    "fields": {
      /**
       * Номер сип-трубки.
       * # Диапазон: 5..14
       */
      "sipNumber": {
        "type": "string",
        "text": "Номер сип-трубки.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Номер помещения.
       * # Диапазон: 1..10000
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер помещения.\n# Диапазон: 1..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
      /**
       * Идентификатор квартиры.
       * # Диапазон: 1..2147483647
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Сообщение об ошибке
       */
      "message": {
        "type": "string",
        "text": "Сообщение об ошибке",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник статусов конфигурации устройства.
   */
  "ConfigureDeviceResultTask.Settings.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов конфигурации устройства.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Настроен
       */
      "SUCCESS": {
        "i": 1,
        "text": "Настроен",
      },
      /**
       * Ошибка
       */
      "ERROR": {
        "i": 2,
        "text": "Ошибка",
      },
    },
  },
}